import { gsap, Sine } from "gsap";

export default class MorePickupItem {
  constructor() {
    this.contents = document.querySelector('._pickup_item');
    if (!this.contents) {
      return;
    }
    this.more = this.contents.querySelector('._more');
    this.close = this.contents.querySelector('._close');

    this.scrollTop;

    this.setup()
  }

  setup () {
    this.more.addEventListener('click', (event) => {

      this.contents.classList.add("open");
      this.more.classList.add("off");
      this.close.classList.add("on");

      this.scrollTop = (document.documentElement || document.body.parentNode || document.body).scrollTop;
    });
    this.close.addEventListener('click', (event) => {

      this.contents.classList.remove("open");
      this.more.classList.remove("off");
      this.close.classList.remove("on");

      gsap.to(document.documentElement, {
        scrollTop: this.scrollTop,
        duration: 0.6,
        ease: Sine.easeInOut
      });
    });
  }

}